<template>
  <div>
    <validation-provider v-if="offerEdition" #default="{ errors }" :name="$t('offer.subscription.specifics.max_hangar')" rules="numeric">
      <b-form-group :label="$t('offer.subscription.specifics.max_hangar')" label-for="offer-subscription-specifics-max-hangar">
        <b-overlay :show="offerSubscriptionLoading">
          <b-form-input
            id="offer-subscription-specifics-max-hangar"
            v-model="items.maxHangars"
            type="number"
            number
            :placeholder="$t('offer.subscription.specifics.max_hangar')"
          />
        </b-overlay>
        <b-tooltip v-if="errors[0]" show target="offer-subscription-specifics-max-hangar" placement="bottom" variant="light">
          <small class="text-danger">{{ errors[0] }}</small>
        </b-tooltip>
      </b-form-group>
    </validation-provider>
    <span v-else>{{ $t('offer.subscription.specifics.max_hangar') }} : {{ items.maxHangars ? items.maxHangars : $t('offer.subscription.specifics.max_hangar_illimited') }}</span>
  </div>
</template>

<script>
export default {
  name: 'OfferPartSubscriptionOptionsHangar',

  props: {
    items: {
      type: Object,
      required: true,
    },
    offerSubscriptionLoading: {
      type: Boolean,
      required: true,
    },
    offerEdition: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
